import { GAME_ATTACK_TYPES } from '../constants/gameAttackConstants';
import AttackController from './AttackController';

class GNSSAttackModel {
    constructor(parameters) {
        /**
         * X coordinate of the center of the GNSS attack zone
         * @type {number}
         */
        this._x = parameters.x;
        /**
         * Y coordinate of the center of the GNSS attack zone
         * @type {number}
         */
        this._y = parameters.y;
        /**
         * Radius of the GNSS attack zone
         * @type {number}
         */
        this._radius = parameters.radius; // in km
        /**
         * Whether the GNSS attack is high power. Affects how the attack is applied to aircraft
         * @type {boolean}
         */
        this._highPower = parameters.highPower;
    }

    getX() {
        return this._x;
    }

    getY() {
        return this._y;
    }

    getRadius() {
        return this._radius;
    }

    isHighPower() {
        return this._highPower;
    }
}

class GNSSAttackController {
    constructor() {
        this._gnssAttacks = [];
    }

    updateAircraft(aircraftModel) {
        const aircraftRelativeX = aircraftModel.positionModel.relativePosition[0];
        const aircraftRelativeY = aircraftModel.positionModel.relativePosition[1];

        if (aircraftRelativeX === undefined || aircraftRelativeY === undefined) {
            return;
        }

        const attacks = this.getGNSSAttacks();

        let isInsideAnyGPSJammingZone = false;

        for (let i = 0; i < attacks.length; i++) {
            const attack = attacks[i];
            const attackX = attack.getX();
            const attackY = attack.getY();
            const attackRadius = attack.getRadius();
            const attackHighPower = attack.isHighPower();

            const distanceToZone = Math.sqrt((aircraftRelativeX - attackX) ** 2 + (aircraftRelativeY - attackY) ** 2);

            if (distanceToZone <= attackRadius) {
                aircraftModel.attackType = GAME_ATTACK_TYPES.GPS_JAMMING;
                if (aircraftModel.GPSAttack === null) {
                    console.log('GNSSAttackController.updateAircraft: creating GPSAttack');
                    AttackController.applyGPSJammingToAircraft(aircraftModel, attackHighPower);
                }
                isInsideAnyGPSJammingZone = true;
                break; // Only one attack can be active at a time
            }
        }

        if (!isInsideAnyGPSJammingZone && aircraftModel.attackType === GAME_ATTACK_TYPES.GPS_JAMMING) {
            console.log('GNSSAttackController.updateAircraft: ending GPSAttack');
            AttackController.endAttack(aircraftModel);
            aircraftModel.attackType = GAME_ATTACK_TYPES.REGULAR; // TODO: What should happen on double guess?
            aircraftModel.guess = 0;
            aircraftModel.hasGuessedCorrect = false;
            aircraftModel.hasGuessed = false;
        }
    }

    // TODO: Add set method to allow for 'dynamic' attacks

    /**
     * Set attacks
     *
     * @param {Array<GNSSAttackModel>} attacks
     * @memberof GNSSAttackController
     */
    setGNSSAttacks(attacks) {
        this._gnssAttacks = attacks;
    }

    /**
     * Get attacks
     *
     * @returns {Array<GNSSAttackModel>}
     * @memberof GNSSAttackController
     */
    getGNSSAttacks() {
        return this._gnssAttacks;
    }
}

export { GNSSAttackController, GNSSAttackModel };
